import { ExpertRequestStage, ExpertRequestState } from '@/__generated__/graphql';

/**
 * effectiveStage mirrors the api `EffectiveStage` (ENG-5290 T1): legacy rows
 * predate the stage backfill and have `stage == null`, so the lifecycle stage
 * is derived from the dual-written `state` — closed → Closed, otherwise Active.
 * A populated `stage` always wins. Keeps the badge/dropdown from ever offering
 * a transition the server would reject for a null-stage row.
 */
export function effectiveStage(
  stage?: ExpertRequestStage | null,
  state?: ExpertRequestState | string | null
): ExpertRequestStage {
  if (stage) {
    return stage;
  }
  return state === ExpertRequestState.Closed || state === 'closed'
    ? ExpertRequestStage.Closed
    : ExpertRequestStage.Active;
}
